import { useTranslation } from "react-i18next";

function PrivacyPolicy() {
  const { t } = useTranslation();
  return (
    <main className="page p-6 max-w-4xl mx-auto space-y-6">
      <header>
        <h1 className="text-3xl font-bold">{t("pages.privacy.title")}</h1>
        <p className="text-sm text-slate-600 mt-1">
          {t("pages.privacy.updated")}
        </p>
      </header>

      <section
        className="prose"
        dangerouslySetInnerHTML={{ __html: t("pages.privacy.html") }}
      />
    </main>
  );
}

export default PrivacyPolicy;
